import React from 'react'
import './DisplayBanner.css'

const DisplayBanner = (props) => {
    return (
        props.displayBanner ? <div className="banner">Zoombies VIP is not supported on this network. Please switch to Moonbeam</div> 
        : <></>
    )
}

export default DisplayBanner